import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { AbsenceSalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { InfosSalariePourAbsenceDto } from "../../../dto/GenApi.iNotPaie.Dto/InfosSalariePourAbsenceDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class ModalAlerteAbsenceCalculeeComponent extends Vue {
	public absenceAAnnuler: AbsenceSalarieDto | undefined;
	public salaries: InfosSalariePourAbsenceDto[] = [];
	public dataReady = false;

	public init(absence: AbsenceSalarieDto): void {
    	this.absenceAAnnuler = absence;
    	this.fetchData();
	}

	public fetchData(): void {
    	$("#modalAlerteAbsenceCalculee").modal("show");
    	this.dataReady = false;
    	if (this.absenceAAnnuler != undefined && this.absenceAAnnuler.Id != undefined) {
            ServicesFactoryInstance.SalarieService.getSalariesAbsenceImposeeCalcule(this.absenceAAnnuler.Id, data => {
    			this.salaries = data;
    			this.doSort();
    			this.dataReady = true;
			}, () => {
				NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la récupération des salariés pour l'absence à annuler.");
				this.cancel();
			});
    	}
	}

	public valider(): void {
    	// Rediriger vers la popup de sélection des salariés
    	$("#modalAlerteAbsenceCalculee").modal("hide");
    	this.$emit("annulerAbsence", this.absenceAAnnuler);
	}

	public cancel(): void {
    	// Rediriger vers la sélection des absences
    	$("#modalAlerteAbsenceCalculee").modal("hide");
    	this.$emit("garderAbsence");
	}

	private doSort(): void {
    	this.salaries.sort(function(a: InfosSalariePourAbsenceDto, b: InfosSalariePourAbsenceDto) {
    		if (a.FullName != undefined && b.FullName != undefined) {
    			if (a.FullName > b.FullName) {
    				return 1;
    			}
    			if (a.FullName < b.FullName) {
    				return -1;
    			}
    		}

    		return 0;
    	});
	}
}



// WEBPACK FOOTER //
// ./src/components/planningAbsences/modalAlerteAbsenceCalculee/modalAlerteAbsenceCalculee.ts